import { render } from "./lead-delete-modal.vue?vue&type=template&id=6426e4f6"
import script from "./lead-delete-modal.vue?vue&type=script&lang=js"
export * from "./lead-delete-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__